<template>
  <div class="xscrollable px-2">
    <v-card class="d-flex flex-row pb-1">
      <v-card
        v-for="(inputVariable, index) in reOrderVariables(sort, [
          ...filteredVars,
        ])"
        :key="'ivcc-' + inputVariable.id"
        :class="index > 0 ? 'ml-2 pb-1' : 'pb-1'"
      >
        <input-variable-chart
          :ref="'ivc-' + inputVariable.id"
          :key="'ivc-' + inputVariable.id"
          :variable="inputVariable"
          :show-filter-help="showFilterHelp"
          :show-analytics-help="showAnalyticsHelp"
          @userResetInputVariable="userChangedInputVariable"
          @userChangedInputVariable="userChangedInputVariable"
          @comparePredefinedRanges="comparePredefinedRanges"
          @savePredefinedRanges="savePredefinedRanges"
        />
      </v-card>
    </v-card>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { state } from '@/store/modules/cohortManager/types';
import InputVariableChart from '@/components/CohortManager/InputVariableChart.vue';
import resize from 'vue-resize-directive';
import { getSetValuedVariableGroups } from '@/utils/helpers';

export default {
  directives: {
    resize,
  },
  components: {
    InputVariableChart,
  },
  props: {
    showFilterHelp: {
      type: Boolean,
      required: false,
      default: false,
    },
    showAnalyticsHelp: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data: () => ({
    inputVariableGroups: { groups: [], var2group: {}, var2var: {} },
    outputVariableGroups: { groups: [], var2group: {}, var2var: {} },
  }),
  computed: {
    ...mapState('cohortManager', {
      inputVariables: state.INPUT_VARIABLES,
      outputVariables: state.OUTPUT_VARIABLES,
      selectedAnalysisMode: state.SELECTED_ANALYSIS_MODE,
      sort: state.SORT,
    }),
    filteredVars() {
      let vars = null;
      let var_groups = null;

      if (this.selectedAnalysisMode == 'Predictor based') {
        vars = this.inputVariables;
        var_groups = this.inputVariableGroups;
      } else {
        vars = this.outputVariables;
        var_groups = this.outputVariableGroups;
      }

      const v2v = var_groups['var2var'];

      // filter grouped variables except for the first
      return vars.filter(v => {
        if (v.label in v2v) {
          return v2v[v.label]['index'] == 1;
        }
        // include all non group variables
        return true;
      });
    },
  },
  watch: {
    inputVariables(niv) {
      this.inputVariableGroups = getSetValuedVariableGroups(niv);
    },
    outputVariables(nov) {
      this.outputVariableGroups = getSetValuedVariableGroups(nov);
    },
  },
  created() {
    this.inputVariableGroups = getSetValuedVariableGroups(this.inputVariables);
    this.outputVariableGroups = getSetValuedVariableGroups(
      this.outputVariables
    );
  },
  methods: {
    reOrderVariables: function(newSort, variables) {
      function getLabel(v) {
        if ('parentLabel' in v) {
          return v.parentLabel;
        }
        return v.label;
      }
      if (newSort == 'Domain') {
        variables.sort(function(a, b) {
          if (a.category < b.category) return -1;
          if (a.category > b.category) return 1;
          return 0;
        });
        return variables;
      }
      if (newSort == 'Variable') {
        variables.sort(function(a, b) {
          if (getLabel(a) < getLabel(b)) return -1;
          if (getLabel(a) > getLabel(b)) return 1;
        });
        return variables;
      } else {
        // use default order imposed by InputVariablesDialog
        return variables;
      }
    },
    userChangedInputVariable() {
      this.$emit('userChangedInputVariable', true);
    },
    comparePredefinedRanges(ranges) {
      this.$emit('comparePredefinedRanges', ranges);
    },
    savePredefinedRanges(ranges) {
      this.$emit('savePredefinedRanges', ranges);
    },
  },
};
</script>

<style scoped>
.horizontal {
  display: flex;
}

.xscrollable {
  overflow-x: auto;
  overflow-y: hidden;
}
.scrollable::-webkit-scrollbar {
  display: none;
}
</style>
